import {
  faBook,
  faCheckCircle,
  faChevronDown,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Component } from 'react';
import { Form, Image, ListGroup, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { GET } from '../../../api';
import { brand_colors } from '../../../helpers/brand_colors_helper';
import { getRegionalStorageURL } from '../../../helpers/regional_storage_url_helper';
import { t } from '../../../helpers/translation_helper';
import { setChildren } from '../../../redux/slices/childrenSlice';
import { setSelectedClass, setSubject, setClassAndSubject } from '../../../redux/slices/selectedClassSlice';

/**
 * Class Subject Unified Selector Partial Component
 */
class ClassSubjectSelector extends Component {
  /**
   * @constructor
   * @param {any} props
   */
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      search: ''
    };
  }

  /**
   * Component Did Mount
   */
  componentDidMount() {
    const { selectedClass } = this.props;
    //!AHMAD  COMMENTED BECAUSE WE ARE NOT USING THIS SLICE ANYMORE
    // this.setChildrenList(selectedClass);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedSubject !== this.props.selectedSubject) {
      this.setState({ modal: false, }, () => {
        if (this.props.func?.length > 0) {
          this.props.func.map((func) => {
            return func();
          });
        }
      });
    }
  }

  /**
   * Handle Modal
   */
  handleModal = () => {
    const { modal } = this.state;
    this.setState({ modal: !modal });
  };


  /**
 * Classes & subjects List
 * @returns {HTMLElement} Outputs the classes list.
 */
  classesSubjectsList = () => {
    let list = [];

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    if (this.props.authData.classes && this.props.authData.classes.length > 0) {
      this.props.authData.classes.forEach((item, classIdx) => {
        if (item.academic_classmain_subject && item.academic_classmain_subject.length > 0) {
          item.academic_classmain_subject.forEach((subject, subjIdx) => {
            // Filter by class_theme or acs_name
            const searchTerm = this.state.search.toLowerCase();
            const classTheme = (item.class.class_theme || '').toLowerCase();
            const subjectName = (subject.acs_name || '').toLowerCase();
            if (
              !classTheme.includes(searchTerm) &&
              !subjectName.includes(searchTerm)
            ) {
              return;
            }
            list.push(
              <ListGroup.Item
                key={`${item.class.class_id}_${subject.acs_id || subjIdx}`}
                className='child-list-item'
                style={{ justifyContent: 'space-between' }}
                onClick={() => {
                  this.props.setClassAndSubject({ class: item, subject: subject });
                  // this.handleClassChange(item.class.class_id);
                  // this.handleSubjectChange(item.class.class_id, subject.acs_id)
                }}
              >
                <div className='d-flex'>
                  <div className='child-pic list-child-pic'>
                    {subject.acs_image ? (
                      <Image
                        src={
                          regionalStorageURL + this.props.authData.centerData.center_uuid +
                          '/academic_classmain_subject/' +
                          subject.acs_image
                        }
                        style={{
                          objectFit: 'cover',
                          width: '100%',
                          height: '100%',
                        }}
                      />
                    ) : (
                      <FontAwesomeIcon icon={faBook} color={brand_colors[this.props.defaultTheme.theme_id].color8} />
                    )}
                  </div>
                  <div className='d-flex flex-column'>
                    <span className='class-name'>
                      {subject.acs_name}
                      {!subject.acs_mandatory &&
                        <Image src={require('../../../assets/images/elective_2.png')}
                          style={{ width: 20, height: 20, objectFit: 'contain' }}
                        />
                      }
                    </span>
                    <div style={{ fontSize: 12 }}>
                      <span>{item.class.class_theme}</span> - <span style={{ fontWeight: 'bold', fontSize: 11, color: item.class.agegroup_color }}>{item.class.agegroup_code}</span>
                    </div>
                  </div>
                </div>
                <div className='d-flex align-items-center'>
                  {(this.props.selectedClass.class.class_id == item.class.class_id && this.props.selectedSubject.acs_id == subject.acs_id) && (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      color={brand_colors[this.props.defaultTheme.theme_id].color4}
                    />
                  )}
                </div>
              </ListGroup.Item>
            );
          });
        } else {
          // Show "No Subjects" if academic_classmain_subject is empty
          list.push(
            <ListGroup.Item
              key={item.class.class_id}
              className='child-list-item'
              style={{ justifyContent: 'space-between' }}
              onClick={() => {
                this.props.setClassAndSubject({ class: item, subject: null });
                // this.handleClassChange(item.class.class_id);
                // this.handleSubjectChange(item.class.class_id, 0)
              }}
            >
              <div className='d-flex'>
                <div className='child-pic list-child-pic'>
                  <FontAwesomeIcon icon={faBook} color={brand_colors[this.props.defaultTheme.theme_id].color8} />
                </div>
                <div className='d-flex flex-column'>
                  <span className='class-name'>
                    {t('No Subjects')}
                  </span>
                  <div style={{ fontSize: 12 }}>
                    <span>{item.class.class_theme}</span> - <span style={{ fontWeight: 'bold', fontSize: 11, color: item.class.agegroup_color }}>{item.class.agegroup_code}</span>
                  </div>
                </div>
              </div>
              <div className='d-flex align-items-center'>
                {(this.props.selectedClass.class.class_id == item.class.class_id) && (
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    color={brand_colors[this.props.defaultTheme.theme_id].color4}
                  />
                )}
              </div>
            </ListGroup.Item>
          );
        }
      });
    }
    return list;
  };

  /**
   * Handle Class Change
   * @param {number} class_id ID of the class
   */
  handleClassChange = (class_id) => {
    const findClass = this.props.authData.classes.find((item) => {
      return item.class.class_id == class_id;
    });

    this.props.setSelectedClass(findClass);

    if (this.props.selectedSubject) {

      const findSubjectIndex = findClass.academic_classmain_subject.findIndex(item => item.acs_id == this.props.selectedSubject.acs_id);

      if (findSubjectIndex !== -1) {
        this.props.setSubject(findClass.academic_classmain_subject?.[findSubjectIndex]);
      } else {
        this.props.setSubject(findClass.academic_classmain_subject?.[0]);
      }

    } else {
      this.props.setSubject(findClass.academic_classmain_subject?.[0]);
    }

    //!AHMAD  COMMENTED BECAUSE WE ARE NOT USING THIS SLICE ANYMORE
    // this.setChildrenList(findClass);

    // this.setState(
    //   {
    //     modal: false,
    //   },
    //   () => {
    //     if (this.props.func?.length > 0) {
    //       this.props.func.map((func) => {
    //         return func();
    //       });
    //     }
    //   }
    // );

  };

  handleSubjectChange = (class_id, subject_id) => {

    const findClass = this.props.authData.classes.find((item) => {
      return item.class.class_id == class_id;
    });

    const findSubject = findClass.academic_classmain_subject.find((item) => {
      return item.acs_id == subject_id;
    });

    this.props.setSubject(findSubject);

  };

  /**
   * Set Children List
   * @param {Object} cls
   */
  setChildrenList = async (cls) => {
    const { authData } = this.props;
    const { center_id, center_timezone } = authData.centerData;
    const { auth_key } = authData.loginData;

    const params = {
      class_id: cls.class.class_id,
    };

    try {
      const res = await GET('children/index', {
        params,
      });
      const timestamp = new Date().getTime();
      for (var i = 0; i < res.data.length; i++) {
        res.data[i].timestamp = timestamp;
      }

      this.props.setChildren(res.data);
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching children!'));

    }
  };

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {

    const { lang_orientation: dir } = this.props.defaultLanguage;
    const { modal, search } = this.state;
    const { authData } = this.props;

    const regionalStorageURL = getRegionalStorageURL(authData.centerData.tenant_id);

    return (
      <>
        {(this.props.minimal)
          ? <div className='selector' style={{ padding: '0 10px', cursor: 'pointer' }}>
            <div className='d-flex flex-row justify-content-center align-items-center' style={{ fontSize: 14, fontWeight: 'bold', color: brand_colors[this.props.defaultTheme.theme_id].color9, opacity: 0.8 }} onClick={() => this.handleModal()}>
              <FontAwesomeIcon
                icon={faCheckCircle}
                color={brand_colors[this.props.defaultTheme.theme_id].color4}
                className='mx-1'
                style={{ fontSize: 18 }}
              />
              <div className='mx-1 d-flex flex-column justify-content-center'
                style={{
                  lineHeight: '13px'
                }}>
                <div>{(this.props.selectedClass) ? this.props.selectedClass.class.class_theme : 'No Class'}</div>
                <div style={{ fontSize: 11, color: (this.props.selectedClass) ? this.props.selectedClass.class.agegroup_color : brand_colors[this.props.defaultTheme.theme_id].color9 }}>{(this.props.selectedClass) ? this.props.selectedClass.class.agegroup_code : ''}</div>
              </div>
              <FontAwesomeIcon
                icon={faChevronDown}
                color={brand_colors[this.props.defaultTheme.theme_id].color2}
                className='mx-1'
                style={{ fontSize: 16 }}
              />
            </div>
          </div>
          : <div className='selector' style={{ /*backgroundColor: '#EDEFF3'*/ }}>
            <div className='child-pic' style={{ width: 40, height: 40, borderColor: '#000' }}>
              {authData.userData.employee_picture ? (
                <Image src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/employees/' + authData.userData.employee_picture}
                  style={{ objectFit: 'cover', width: '100%', height: '100%', }}
                />
              ) : (
                <FontAwesomeIcon icon={faUser} color={brand_colors[this.props.defaultTheme.theme_id].color8} />
              )}
            </div>
            <div className='d-flex align-items-center cursor-pointer' onClick={() => this.handleModal()}>
              <h5 className='child-name' style={{ textTransform: 'capitalize', padding: 0 }}>
                <span>
                  {dir == 0 && t('Hi,')}{' '}
                  {authData.loginData.full_name}{' '}
                  {dir == 1 && t('Hi,')}
                </span>
              </h5>
              <span className='mx-2'>•</span>
              <h5 className='class-name m-0' style={{ color: '#77787A', fontWeight: 'bold' }}>
                {(this.props.selectedClass) ? this.props.selectedClass.class.class_theme : 'No Class'}{' '}
              </h5>
              <span className='mx-2'>•</span>
              <h5 className='class-name m-0 me-2' style={{ color: '#77787A', }}>
                {(this.props.selectedSubject) ? this.props.selectedSubject.acs_name : 'No Subject'}{' '}
              </h5>
              <FontAwesomeIcon
                icon={faChevronDown}
              />
            </div>
          </div>
        }

        <Modal show={modal} size='sm' onHide={this.handleModal}>
          <Modal.Header>
            <div className='d-flex flex-column' style={{ width: '100%' }}>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <Modal.Title>{t('Select Class & Subject')}</Modal.Title>
                <button
                  type='button'
                  className='btn-close'
                  aria-label='Close'
                  onClick={this.handleModal}
                ></button>
              </div>
              <div >
                <Form.Control
                  type='text'
                  placeholder={t('Search...')}
                  onChange={(e) => this.setState({ search: e.target.value })}
                  value={search}
                />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className='p-0 pb-2'>
            <ListGroup variant='flush'>
              {this.classesSubjectsList()}
            </ListGroup>
          </Modal.Body>
        </Modal >
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedClass: state.selectedClass.data,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
  selectedSubject: state.selectedClass.subject,
});

const mapDispatchToProps = () => ({
  setClassAndSubject,
  setChildren,
});

export default connect(mapStateToProps, mapDispatchToProps())(ClassSubjectSelector);
